<template>
  <div class="flex-container">
    <div v-if="text" class="text" :style="{ fontSize: textSize, color: textColor }">
      {{ text }}
      <span v-if="asteriks">*</span>
    </div>
    <NewTooltip
      :placement="placement" :max-width="240" :custom-width="customWidth" :hover="hover"
      :teleport-to-body="teleportToBody"
    >
      <img
        v-if="isTriggerIcon" class="trigger-img" :class="{ 'disabled-icon': disabledTriggerIcon }" :src="triggerIcon || infoIcon"
        alt="" :style="{ height: iconSize }"
      >
      <template #content>
        <slot>
          <div style="display: flex; flex-direction: row; gap: 8px">
            <img v-if="isTooltipIcon" :src="tooltipIcon || infoIcon" alt="" :style="{ height: iconSize }">
            <div class="tooltip-text-container">
              <slot name="text-with-icon">
                {{ tooltip }}
              </slot>
            </div>
          </div>
        </slot>
      </template>
    </NewTooltip>
  </div>
</template>

<script setup lang="ts">
import { NewTooltip } from '@/components/common'
import { Placement } from '@floating-ui/vue'
import infoIcon from '@/assets/icons/Icon_Info_Gray.svg'
interface TextIconTooltip {
  text?: string //for text that's already translated or doesn't need translation
  textSize?: string
  textColor?: string
  triggerIcon?: string // icon that, when clicked, opens a tooltip
  isTriggerIcon?: boolean
  disabledTriggerIcon?: boolean // if true, the trigger icon will be disabled
  tooltipIcon?: string // icon that is part of the description content of the tooltip
  isTooltipIcon?: boolean
  iconSize?: string // example: '16px'
  tooltip?: string //for text that's already translated or doesn't need translation
  placement?: Placement
  asteriks?: boolean
  hover?: boolean
  customWidth?: number
  teleportToBody?: boolean
}

withDefaults(defineProps<TextIconTooltip>(), {
  placement: 'right-start',
  iconSize: '1rem',
  textSize: '16px',
  isTriggerIcon: true,
  isTooltipIcon: true,
  hover: false,
  teleportToBody: true
})
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  align-items: center;

  .trigger-img {
    cursor: pointer;
    margin-left: 4px;

    &.disabled-icon {
      opacity: 0.5;
      cursor: auto;
    }
  }
}
</style>
